import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { TechnologyForCreationResponse, SetBoardAssociationTektone, GetSpaceDetailsBoardSetupTektone, DeleteConfigurationTektone, GetAlertConfigBoard, GetAlertConfigSpace } from '../../technologyoverlay';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { RollbarService } from '../../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck, generateAlertMessage } from '../../../../app-general';
import {Router} from '@angular/router';
import { Http } from '@angular/http';
import { ApiService } from '../../../../api.service';
import { takeUntil } from 'rxjs/operators';
import { AlertSharedService } from '../../../../_services/index';
import { GeneralMessageComponent } from '../../../../general-message/general-message.component';

@Component({
 
  selector: 'app-edit-config',
  templateUrl: './edit-config.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-config.component.scss']
})
export class TekToneEditConfigComponent implements OnInit,OnDestroy {

  watcher: Subscription;
  columns = 4;
  firstcolumns = 2;
  downIcon = 0;
 
  minheight = "230px";
  location;
  deleteConfigId;
  flag = 0;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  editConfigrowHeight = "79px";
  screenWidth;
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  isundo = 0;
  undooperation = true;
  undopane = 0
  dataSource;
  dataSourcecnt;
  boardSetupData = [];
  configuredSetupData = [];
  displayedColumns: string[]= ["RoomId","Event","SpaceName","Index"];
  public configeditForm : FormGroup;
  selectedSpaceId;
  selectedBoardName = "";
  existingData = [];
  boardlength = 0;
  boardId;
  spaceId = 0;
 
  constructor(public http: Http,private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<TekToneEditConfigComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
          private technologyoverlayService: TechnologyoverlayService,private alertSharedService: AlertSharedService,
          public dialog: MatDialog,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService) 
  {
    try
      {
          this.selectedBoardName = data.BoardName;          
          this.boardlength = data.setupDataRowCount;
        
          this.boardId = data.BoardId;
         
                
          this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
            
          if (change) {        
                if (change.mqAlias == 'xs') {
                  this.columns = 2;  
                  this.firstcolumns = 1;      
                  this.minheight = "auto";            
                } 
                else if (change.mqAlias == 'sm') {
                  this.columns = 2;
                  this.firstcolumns = 2;  
                  this.minheight = "auto";         
                }  
                else if (change.mqAlias == 'md') {
                  this.columns = 2;  
                  this.firstcolumns = 1;  
                  this.minheight = "230px";      
                }               
                else
                {
                  this.columns = 4;  
                  this.firstcolumns = 2;    
                  this.minheight = "230px";          
                }
            }
          });

      }
      catch(err)
      {
        throw new Error('edit-config.component.ts' + ' - constructor() - ' + err.message);
      }
  }

  ngOnInit() 
  {  
    try
    {
       this.configeditForm = new FormGroup({                                
            boardname:new FormControl(''),
            ipaddress:new FormControl(''),                                 
            udpport:new FormControl(''),           
            hdnFileName: new FormControl(''),
            hdnBoardName: new FormControl(''),
            hdnIpAddress: new FormControl(''),
            hdnUdpPort: new FormControl(''),
        });
        for (let i = 1; i <= this.boardlength; i++) 
        {
          this.configeditForm.controls['mat_select_' + i] =  new FormControl('');
        }  
        this.configeditForm.get('boardname').disable();
        this.configeditForm.get('ipaddress').disable();
        this.configeditForm.get('udpport').disable();
        this.getSpaceDetailsWithBoardSetupData();
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - ngOnInit() - ' + err.message);
    }
  }

  handleInput(event) 
  { 
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.configeditForm.controls).forEach(field => { // {1}
        const control = this.configeditForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('edit-config.component.ts' + ' - handleInput() - ' + err.message);
    }
  }

  getSpaceDetailsWithBoardSetupData()
  {
    try
    {
      let getSpaceInfo: GetSpaceDetailsBoardSetupTektone = {
           authKey: localStorage.getItem("Authkey")
        }
        this.technologyoverlayService.getSpaceDetailsWithBoardSetupDataTekTone(getSpaceInfo).pipe(takeUntil(this._onDestroy))
        .subscribe((SpaceDetails: any[])=>{
          this.boardSetupData = SpaceDetails;
          this.dataSource = new MatTableDataSource( SpaceDetails);
          this.dataSource.data =  SpaceDetails;
          this.dataSourcecnt =  SpaceDetails.length;
        });
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - getSpaceDetailsWithBoardSetupData() - ' + err.message);
    }
  }

  public onCloseCancel = () => 
  {   
    try
    {
      if(!SessionCheck(this.router))
      {
          return;
      }
      this.thisDialogRef.close('Cancel');
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - onCloseCancel() - ' + err.message);
    }
  }

  public hasError = (controlName: string, errorName: string) =>
  {
    try
    {
      return this.configeditForm.controls[controlName].hasError(errorName);
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - hasError() - ' + err.message);
    }
  }

  public oneditConfigdetails = (ConfigFormValue) => 
  {  
    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      
      if (this.configeditForm.valid) {
         this.saveConfigurationSettings(ConfigFormValue);
      }
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - oneditConfigdetails() - ' + err.message);
    }
  }

  private saveConfigurationSettings = (ConfigFormValue) => 
  {
    try
    {
      (document.activeElement as HTMLTextAreaElement).blur();
       if (this.configeditForm.valid) 
       {
          let saveclick = document.getElementById('btnsaveclick');
          saveclick.className = 'clsconfigeditbutton mat-raised-button disablebtn';              
          var _arrSaveBoardSetupDetails = [];
          for(var i=0;i<this.boardSetupData.length;i++)
          {
            var _SaveBoardSetupDetails = {};
            _SaveBoardSetupDetails['RoomId'] = this.boardSetupData[i].RoomId;
            _SaveBoardSetupDetails['Event'] = this.boardSetupData[i].Event;
            _SaveBoardSetupDetails['SpaceId'] = this.boardSetupData[i].SpaceName;
            _arrSaveBoardSetupDetails.push(_SaveBoardSetupDetails);
          }

          let saveboardAssociation : SetBoardAssociationTektone= {
            authKey: localStorage.getItem("Authkey"),
            jsonData:JSON.stringify(_arrSaveBoardSetupDetails),
          }
          this.technologyoverlayService.saveBoardAssociationTekTone(saveboardAssociation).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : any[])=>{
            console.log(apiresponse)
            if(apiresponse.toString() == "Success")
            { 	      
              generateAlertMessage(this.dialog, 'Board Configured Successfully.')
              this.thisDialogRef.close();
            }  
          });           
        }
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - saveConfigurationSettings() - ' + err.message);
    }
 }
 
  opendeleteconfigdialog() 
  { 
    try
    {
      var GeneralMessageData = {
        General_header: "Delete Board",                
        GeneralMessage: "Are you sure you would like to delete this Board?",
        General_first: "Yes",
        General_second: "No"
      }   

      let dialogRef = this.dialog.open(GeneralMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: '220px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: GeneralMessageData
      }); 

      dialogRef.afterClosed().subscribe(result => {     
        if(result == "First")
        {                     
          this.deleteConfigurationSettings();               
        }
        else
        {                
          dialogRef.close('Cancel');          
          return;
        }            
      });        
    }
    catch(err)
    {
      throw new Error('edit-config.component.ts' + ' - opendeletedialog() - ' + err.message);
    }
  }

 deleteConfigurationSettings()
 {
    try
    {
       let checkAlertByBoardId : GetAlertConfigBoard = {
         siteId: this.SiteId,
         authKey: localStorage.getItem("Authkey"),
         boardId: this.boardId
      }
      this.technologyoverlayService.getAlertForConfiguredBoard(checkAlertByBoardId).pipe(takeUntil(this._onDestroy))
       .subscribe((apiresponse : TechnologyForCreationResponse[])=>{         
           if(apiresponse.toString() == "yes")
           {
             generateAlertMessage(this.dialog, 'Board has open alerts, please complete or cancel those alerts and try again.');
           }
           else
           {
              let deleteConfigByBoardName : DeleteConfigurationTektone = {
              authKey: localStorage.getItem("Authkey")
            }
          
            this.technologyoverlayService.deleteConfigurationSettingsTekTone(deleteConfigByBoardName).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : TechnologyForCreationResponse[])=>{         
            if(apiresponse.toString() == "true")
            { 	      
              generateAlertMessage(this.dialog, 'Board Configuration deleted successfully.')
            }    
            else if(apiresponse.toString() == "false")
            {          
              generateAlertMessage(this.dialog, 'Board Configuration deleted failed.')
            }
            this.thisDialogRef.close();  
            });
          }
      });
    }    
    catch(err)
    {
        throw new Error('edit-config.component.ts' + ' - deleteConfigurationSettings() - ' + err.message);
    }   
  } 
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
